<template>
  <h1>
    {{$t('page-not-found')}}
  </h1>
</template>


<script>
export default {
  name: 'page-not-found'
};
</script>

<style scoped>
h1 {
  padding: 2rem;
  font-size: 1.5rem !important;
}
</style>

